import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'localize',
  standalone: true
})
export class LocalizePipe implements PipeTransform {
  transform(key: string, ...args: any[]): string {
    const localizeFn = window.custom?.l10n?.localize;
    if (typeof localizeFn === 'function') {
      const localizedText = localizeFn(key);
      if (!localizedText || args.length === 0) {
        return localizedText ?? key;
      }
      return localizedText.replace(/{(\d+)}/g, (match, index) => {
        const i = parseInt(index, 10);
        return typeof args[i] !== 'undefined' ? args[i] : match;
      });
    }
    return key;
  }
}